import React from 'react';
import AdvertPage from '../../screens/AdvertPage/AdvertPage.component';
import { AdvertEntity } from '../../../domain';
import { useLocation, useParams } from 'react-router-dom';

const UpdatedAdvert: React.FC = () => {
  const location = useLocation();
  const params = useParams();
  const fromState = (location.state as { advert?: AdvertEntity } | null)?.advert;
  const advertUUID = fromState?.uuid || (params.advertId as string);
  return <AdvertPage advertUUID={advertUUID} />;
};

export default UpdatedAdvert;
